export default {"src":"/_next/static/media/nlc2.a772ce72.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};